webpackJsonp([42121630397274],{

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.SheShines = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(18);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Modal = __webpack_require__(8);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _reactSlick = __webpack_require__(15);
	
	var _reactSlick2 = _interopRequireDefault(_reactSlick);
	
	__webpack_require__(13);
	
	__webpack_require__(12);
	
	var _reactLinkedinInsight = __webpack_require__(16);
	
	var _reactLinkedinInsight2 = _interopRequireDefault(_reactLinkedinInsight);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var icon1 = "https://winpeforum.com/assets/elements/KrunaliShah.jpg";
	var icon2 = "https://winpeforum.com/assets/elements/KhushbooShahani.png";
	var icon3 = "https://winpeforum.com/assets/elements/RheaGrover.jpg";
	var icon4 = "https://winpeforum.com/assets/elements/SapnaGoyal.jpg";
	var icon5 = "https://winpeforum.com/assets/elements/SanjnaTulsiani.png";
	
	var duration = 400;
	
	var TeamModal = function TeamModal(_ref) {
	  var activeItem = _ref.activeItem,
	      show = _ref.show,
	      onHide = _ref.onHide;
	
	  return _react2.default.createElement(
	    _Modal2.default,
	    {
	      direction: "",
	      className: "teamdetails__wrapper",
	      show: show,
	      onHide: onHide
	    },
	    _react2.default.createElement(
	      _Modal2.default.Header,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "head_section" },
	        _react2.default.createElement(
	          "span",
	          { className: "item_name" },
	          activeItem.name
	        ),
	        _react2.default.createElement("div", {
	          className: "item_des",
	          dangerouslySetInnerHTML: { __html: activeItem.post }
	        })
	      ),
	      _react2.default.createElement(
	        "span",
	        { className: "cross pull-right" },
	        _react2.default.createElement("i", { onClick: onHide, className: "fa fa-times" })
	      )
	    ),
	    _react2.default.createElement(
	      _Modal2.default.Body,
	      null,
	      _react2.default.createElement(
	        "div",
	        { className: "item__desc" },
	        _react2.default.createElement("div", { dangerouslySetInnerHTML: { __html: activeItem.desc } })
	      )
	    ),
	    _react2.default.createElement(_Modal2.default.Footer, null)
	  );
	};
	
	TeamModal.propTypes = {
	  activeItem: _propTypes2.default.object,
	  show: _propTypes2.default.object,
	  onHide: _propTypes2.default.object
	};
	
	var SheShines = exports.SheShines = function (_React$Component) {
	  _inherits(SheShines, _React$Component);
	
	  function SheShines(args) {
	    _classCallCheck(this, SheShines);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateWindowDimensions = function () {
	      var slidesToShow = _this.state.slidesToShow;
	      // // console.log("width", window.innerWidth)
	
	      if (window.innerWidth <= 768 && window.innerWidth > 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else if (window.innerWidth <= 500) {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      } else {
	        if (slidesToShow !== 1) {
	          _this.setState({
	            slidesToShow: 1
	          });
	        }
	      }
	    };
	
	    _this.togglePopUp = function (item) {
	      _this.setState({
	        isShow: !_this.state.isShow,
	        activeItem: item || {}
	      });
	    };
	
	    _this.state = {
	      slidesToShow: 1,
	      activeItem: {},
	      isShow: false,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    _this.Speaker2 = [{
	      imgUrl: icon5,
	      desc: "<div>\n      Sanjna has over 10 years of experience across venture growth investing, equity research and investor\nrelations. She is a Senior Vice President at Iron Pillar and has been part of the founding team since\n2018. At Iron Pillar, she is involved in the entire deal lifecycle from sourcing, due diligence and\ndocumentation to portfolio company monitoring and exit. Additionally, she contributes towards investor\nrelations and marketing.<br/><br/>\nSanjna is a CFA\xAE Charter holder. She holds a Masters in Commerce (Finance & Accounting) and\nBachelors in Management Studies (Finance) from the University of Mumbai.\n\n          </div>",
	      name: "Sanjna Tulsiani",
	      post: "<div>Senior Vice President, Investments<br/>Iron Pillar\n          </div>"
	    }];
	    _this.Speaker1 = [{
	      imgUrl: icon1,
	      desc: "<div>\n      Krunali Shah has been an Investor with A91 Partners for 5 years. She is involved with investments\nacross consumer brands, financial services and technology. Prior to joining A91, Krunali was a part of\nthe Boston Consulting Group. She has graduated from IIM Ahmedabad and is a Chartered Accountant.\n\n          </div>",
	      name: "Krunali Shah Pinjani",
	      post: "<div>Investor<br/> A91 Partners\n          </div>"
	    }, {
	      imgUrl: icon2,
	      desc: "<div>\n      Khushboo Shahani is Executive Director at Eversource Capital, focusing on investments in energy\nefficiency, resource efficiency, and e-mobility. With over 14 years of experience, she has managed\nnearly USD 1 billion across private equity, credit, and special situations. Previously, she was VP at\nEverstone Capital, deploying over USD 150 million, and Chief Manager at SBI Funds, handling\ndistressed assets. Khushboo holds an MBA from SP Jain Institute of Management & Research and a\nB.Com from St. Francis College, Hyderabad.\n          \n          </div>",
	      name: "Khushboo Shahani",
	      post: "<div>Executive Director<br/>Eversource Capital\n\n          </div>"
	    }, {
	      imgUrl: icon3,
	      desc: "At Warburg, Rhea spends most of her time looking at the Financial Services, FinTech and Consumer\nsectors. Prior to joining Warburg, Rhea worked at L.E.K. Consulting, United Nations Development\nProgramme, and as a business head at a FinTech startup. She completed her Bachelor\u2019s from Lady\nShri Ram College at Delhi University and MBA from The Wharton School at The University of\nPennsylvania.\n             ",
	      name: "Rhea Grover",
	      post: "<div> Vice President<br/>Warburg Pincus\n            </div>"
	    }, {
	      imgUrl: icon4,
	      desc: "Sapna Goyal is a seasoned investor with over 12 years of experience in early and growth-stage tech startups\nin India. At WaterBridge Ventures, she leads seed and pre-Series A investments in AI-SaaS and DeepTech.\nPreviously, she led M&A and Strategy at Udaan, raising $800M+ and driving key initiatives. She began her\ncareer as a growth-stage tech investor at Goldman Sachs. Sapna holds an MBA from IIM Kozhikode and a\nbachelor\u2019s from Lady Shri Ram College. She is passionate about entrepreneurship, technology, and building a more inclusive investment ecosystem. \n\n    \n             ",
	      name: "Sapna Goyal",
	      post: "<div>Vice President<br/> WaterBridge Ventures\n            </div>"
	    }];
	
	    return _this;
	  }
	
	  SheShines.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    this.updateWindowDimensions();
	    window.addEventListener("resize", this.updateWindowDimensions);
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    _reactLinkedinInsight2.default.init("2117884");
	    _reactLinkedinInsight2.default.track("2310748");
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  SheShines.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener("resize", this.updateWindowDimensions);
	  };
	
	  SheShines.prototype.render = function render() {
	    var _this3 = this;
	
	    var _state = this.state,
	        defaultStyle = _state.defaultStyle,
	        isShow = _state.isShow,
	        slidesToShow = _state.slidesToShow;
	    var location = this.props.location;
	
	    var settings = {
	      dots: false,
	      infinite: true,
	      speed: 6000,
	      autoplay: true,
	      slidesToShow: slidesToShow,
	      slidesToScroll: slidesToShow,
	      autoplaySpeed: 7000,
	      arrows: true
	    };
	    console.log("render", this.render1, slidesToShow);
	    this.render1 = this.render1 + 1;
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Understanding PEVC Culture: Career Progression and Promotion Paths",
	        image: "https://winpeforum.com/api/src/templates/emailers/assets/newsletter2022.png",
	        description: "Winpe Ignite sessions made a resounding comeback with the PEVC Career Talk Series on the 14th December 2024.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content", style: defaultStyle },
	        _react2.default.createElement(
	          "div",
	          { className: "toastshine_wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_event" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/events/" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Events"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "toastshine_section" },
	            _react2.default.createElement(
	              "div",
	              { className: "m_heading" },
	              "PEVC Career Talk Series | Session 02",
	              _react2.default.createElement("br", null),
	              "Understanding PEVC Culture: Career Progression and Promotion Paths"
	            ),
	            _react2.default.createElement("div", { className: "r_btm" }),
	            _react2.default.createElement(
	              "div",
	              { className: "date_heading" },
	              _react2.default.createElement(
	                "div",
	                { className: "date_heading" },
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  "May 17, 2025"
	                ),
	                _react2.default.createElement("br", null),
	                _react2.default.createElement(
	                  "span",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "i",
	                    null,
	                    "Online"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { className: "top_text", style: { textAlign: 'justify' } },
	              "This session of Winpe\u2019s  ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "PEVC Career Talk Series"
	              ),
	              " was held on ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "17th May 2025"
	              ),
	              ", offering participants a glimpse into the career dynamics in the organizational landscape of the Private Equity and Venture Capital (PEVC) industry. The session received ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "great positive feedback where 100% of the participants found the session and its contents to be valuable."
	              ),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Here is a ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://youtu.be/lWDNdDF4Xt8", target: "_blank", style: { color: 'blue', textDecoration: 'underline' } },
	                "link"
	              ),
	              " to the recording of the session.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Focusing on the theme ",
	              _react2.default.createElement(
	                "b",
	                null,
	                "\u201CUnderstanding PEVC Culture: Career Progression and Promotion Paths,\u201D"
	              ),
	              " the session explored how professionals grow within PEVC firms, what defines success, how performance is assessed, and the structures that support advancement.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "Speakers shared real-life insights into firm culture, team dynamics, and the pathways to leadership roles, helping participants understand not just how to enter the industry, but how to build a sustainable and fulfilling career within it.",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              "The cherry on the cake was the acknowledgment for Winpe\u2019s significant work in equipping women with the skills needed for roles in the PEVC industry",
	              _react2.default.createElement("br", null),
	              _react2.default.createElement("br", null),
	              _react2.default.createElement(
	                "h3",
	                null,
	                _react2.default.createElement(
	                  "b",
	                  null,
	                  "Key Highlights:"
	                )
	              ),
	              _react2.default.createElement(
	                "ul",
	                null,
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  " ",
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Structured Yet Competitive Progression:"
	                    )
	                  ),
	                  "PEVC firms typically follow a clear hierarchy\u2014Analyst, Associate, Vice President, Principal, and Partner\u2014but progression is highly performance-driven. Advancing requires not just tenure but demonstrated deal execution, origination ability, and firm fit."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Deal Experience is Currency:"
	                    )
	                  ),
	                  "Success and promotion are often tied to your ability to contribute meaningfully to deals. This includes sourcing, diligence, execution, and portfolio management. The more you build a track record of successful investments, the faster you progress."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Cultural Fit and Relationship Building Matter:"
	                    )
	                  ),
	                  "Promotion isn\u2019t just about technical skills\u2014it also depends on how well you align with the firm\u2019s culture, values, and leadership. Building trust with senior partners, LPs, and portfolio founders is crucial."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Mentorship Matters:"
	                    )
	                  ),
	                  "Mentorship can be a key enabler for career advancement. One can seek mentors even through cold emails and get advice on how to navigate challenges and opportunities in the industry."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Path to Partnership Varies by Firm:"
	                    )
	                  ),
	                  "Reaching Partner level is a long-term game and varies by firm structure. Some firms promote internally based on merit and longevity, while others bring in lateral hires with sector expertise or strong networks."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Promotions Tied to Fund Performance:"
	                    )
	                  ),
	                  "In many domestic PEVC firms, career progression is heavily influenced by how the fund performs\u2014often up to 50% of promotion decisions are based on fund outcomes. Unlike global firms with more standardized promotion tracks, this creates a stronger link between team success and individual advancement."
	                ),
	                _react2.default.createElement(
	                  "li",
	                  null,
	                  _react2.default.createElement(
	                    "h5",
	                    null,
	                    _react2.default.createElement(
	                      "b",
	                      null,
	                      "Principal Role should Mirror Early Partner Responsibilities:"
	                    )
	                  ),
	                  "At the Principal level, expectations go beyond execution\u2014you're expected to act like a Partnerin-waiting. This includes owning deals, managing portfolio companies and exits, holding board seats, contributing to firm branding, and increasingly engaging with LPs and fundraising. Principals are also seen as sector thought leaders and are often granted authority to write smaller checks, signaling readiness for partnership."
	                )
	              ),
	              _react2.default.createElement("br", null),
	              "Q&A included questions on long-term growth opportunities in PEVC and the skills and mindset needed to thrive.",
	              _react2.default.createElement("br", null)
	            ),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement("br", null),
	            _react2.default.createElement(
	              "div",
	              { "class": "row" },
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Speakers"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '100%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker1.map(function (item, i) {
	                          if (i <= 2) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-3 col-sm-12 col-lg-36",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-3 col-sm-12 col-lg-3",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { "class": "col-md-12" },
	                _react2.default.createElement(
	                  "h2",
	                  { "class": "ignite-ask-me-anything__heading", style: { fontSize: "30px" } },
	                  "Moderator"
	                ),
	                "          ",
	                _react2.default.createElement("div", { "class": "r_btm" }),
	                _react2.default.createElement(
	                  "div",
	                  { className: "Our_Speakers container" },
	                  _react2.default.createElement(
	                    "center",
	                    null,
	                    _react2.default.createElement(
	                      "div",
	                      { className: "Speakers_img", style: { width: '100%' } },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "row" },
	                        this.Speaker2.map(function (item, i) {
	                          if (i <= 2) {
	                            return _react2.default.createElement(
	                              "div",
	                              {
	                                className: "main_speaker_card col-md-12 col-sm-12 col-lg-12",
	                                key: i
	                              },
	                              _react2.default.createElement(
	                                "div",
	                                { className: "Scardd" },
	                                _react2.default.createElement(
	                                  "div",
	                                  {
	                                    className: "s_img",
	                                    onClick: function onClick() {
	                                      return _this3.togglePopUp(item);
	                                    }
	                                  },
	                                  _react2.default.createElement(
	                                    "center",
	                                    null,
	                                    "  ",
	                                    _react2.default.createElement("img", {
	                                      src: item.imgUrl,
	                                      alt: item.name,
	                                      className: "img-responsive",
	                                      style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                    })
	                                  )
	                                ),
	                                _react2.default.createElement("br", null),
	                                "    ",
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_name",
	                                  dangerouslySetInnerHTML: { __html: item.name }
	                                }),
	                                _react2.default.createElement("div", {
	                                  className: "Speakers_post",
	                                  dangerouslySetInnerHTML: { __html: item.post }
	                                })
	                              )
	                            );
	                          } else return _react2.default.createElement(
	                            "div",
	                            {
	                              className: "main_speaker_card col-md-6 col-sm-6 col-lg-6",
	                              key: i
	                            },
	                            _react2.default.createElement(
	                              "div",
	                              { className: "Scardd" },
	                              _react2.default.createElement(
	                                "div",
	                                {
	                                  className: "s_img",
	                                  onClick: function onClick() {
	                                    return _this3.togglePopUp(item);
	                                  }
	                                },
	                                _react2.default.createElement(
	                                  "center",
	                                  null,
	                                  "  ",
	                                  _react2.default.createElement("img", {
	                                    src: item.imgUrl,
	                                    alt: item.name,
	                                    className: "img-responsive",
	                                    style: { borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }
	                                  })
	                                )
	                              ),
	                              _react2.default.createElement("br", null),
	                              "    ",
	                              _react2.default.createElement("div", {
	                                className: "Speakers_name",
	                                dangerouslySetInnerHTML: { __html: item.name }
	                              }),
	                              _react2.default.createElement("div", {
	                                className: "Speakers_post",
	                                dangerouslySetInnerHTML: { __html: item.post }
	                              })
	                            )
	                          );
	                        })
	                      )
	                    ),
	                    _react2.default.createElement("br", null),
	                    _react2.default.createElement("br", null)
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(TeamModal, {
	            show: isShow,
	            onHide: this.togglePopUp,
	            activeItem: this.state.activeItem
	          })
	        )
	      )
	    );
	  };
	
	  return SheShines;
	}(_react2.default.Component);
	
	SheShines.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = SheShines;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pevc-career-talk-session-2-index-js-fc5e06996167d4e04be4.js